import { useCallback, useState } from "react";
import { SCHEDULE_LATER, SCHEDULE_NOW } from "./NewsletterScheduleSection";
import { getScheduleAtValidationError } from "./newsletterScheduleValidation";
import { isCompleteDatetimeLocal } from "../../../../utils/newsletterDateUtils";

export function useNewsletterScheduleState() {
  const [scheduleMode, setScheduleMode] = useState(SCHEDULE_NOW);
  const [scheduledAt, setScheduledAt] = useState("");
  const [scheduledAtError, setScheduledAtError] = useState("");

  const handleScheduleModeChange = useCallback((nextMode) => {
    setScheduleMode(nextMode);
    if (nextMode !== SCHEDULE_LATER) {
      setScheduledAtError("");
    }
  }, []);

  const handleScheduledAtChange = useCallback((value) => {
    setScheduledAt(value);
    if (isCompleteDatetimeLocal(value)) {
      setScheduledAtError("");
    }
  }, []);

  const validateSchedule = useCallback(() => {
    const error = getScheduleAtValidationError(scheduleMode, scheduledAt);
    setScheduledAtError(error);
    return !error;
  }, [scheduleMode, scheduledAt]);

  return {
    scheduleMode,
    scheduledAt,
    scheduledAtError,
    handleScheduleModeChange,
    handleScheduledAtChange,
    validateSchedule,
  };
}
